import { Control, Controller, FieldValues, Path } from 'react-hook-form'

import SelectInput2, { SelectInput2Props } from './SelectInput2'

type SelectInputControllerProps<T extends FieldValues> = {
    control: Control<T>
    name: Path<T>
} & Omit<SelectInput2Props, 'value' | 'onChange' | 'name'>

export default function SelectInputController<T extends FieldValues>({
    control,
    name,
    ...rest
}: SelectInputControllerProps<T>) {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
                <SelectInput2
                    {...rest}
                    name={name}
                    onChange={onChange}
                    value={value}
                    ref={ref}
                    error={!!error}
                    helperText={error?.message}
                />
            )}
        />
    )
}
